import { appModuleIds, stepsListIndexes } from '@/shared/constants'

export const componentsMappingByAppModule = {
    [stepsListIndexes.districtsStepIndex]: {
        [appModuleIds.AGNKS]: () =>
            import('@/pages/AGNKS/ObjectsViewAGNKS/ObjectsViewAGNKS.vue'),
        default: () => import('@/pages/DistrictsView/index.vue'),
    },
}
